// FETCH ALL ACCESSORIES_USAGE
export const FETCH_ACCESSORIES_USAGE_REQUEST = 'FETCH_ACCESSORIES_USAGE_REQUEST';
export const FETCH_ACCESSORIES_USAGE_SUCCESS = 'FETCH_ACCESSORIES_USAGE_SUCCESS';
export const FETCH_ACCESSORIES_USAGE_FAILURE = 'FETCH_ACCESSORIES_USAGE_FAILURE';

// CREATE ACCESSORIES_USAGE
export const CREATE_ACCESSORIES_USAGE_REQUEST = 'CREATE_ACCESSORIES_USAGE_REQUEST';
export const CREATE_ACCESSORIES_USAGE_SUCCESS = 'CREATE_ACCESSORIES_USAGE_SUCCESS';
export const CREATE_ACCESSORIES_USAGE_FAILURE = 'CREATE_ACCESSORIES_USAGE_FAILURE';

// UPDATE ACCESSORIES_USAGE
export const UPDATE_ACCESSORIES_USAGE_REQUEST = 'UPDATE_ACCESSORIES_USAGE_REQUEST';
export const UPDATE_ACCESSORIES_USAGE_SUCCESS = 'UPDATE_ACCESSORIES_USAGE_SUCCESS';
export const UPDATE_ACCESSORIES_USAGE_FAILURE = 'UPDATE_ACCESSORIES_USAGE_FAILURE';

// FETCH SINGLE STATE
export const FETCH_SINGLE_ACCESSORIES_USAGE_REQUEST = 'FETCH_SINGLE_ACCESSORIES_USAGE_REQUEST';
export const FETCH_SINGLE_ACCESSORIES_USAGE_SUCCESS = 'FETCH_SINGLE_ACCESSORIES_USAGE_SUCCESS';
export const FETCH_SINGLE_ACCESSORIES_USAGE_FAILURE = 'FETCH_SINGLE_ACCESSORIES_USAGE_FAILURE';

// DELETE ACCESSORIES_USAGE
export const DELETE_ACCESSORIES_USAGE_REQUEST = 'DELETE_ACCESSORIES_USAGE_REQUEST';
export const DELETE_ACCESSORIES_USAGE_SUCCESS = 'DELETE_ACCESSORIES_USAGE_SUCCESS';
export const DELETE_ACCESSORIES_USAGE_FAILURE = 'DELETE_ACCESSORIES_USAGE_FAILURE';

export const RESET_ACCESSORIES_USAGE_INFO = 'RESET_ACCESSORIES_USAGE_INFO';

export const CREATE_ACCESSORIES_USAGE_FORM = 'CREATE_ACCESSORIES_USAGE_FORM';

export const UPDATE_ACCESSORIES_USAGE_FORM = 'UPDATE_ACCESSORIES_USAGE_FORM';
